"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get SqlClientFactory () {
        return SqlClientFactory;
    },
    get default () {
        return _class;
    }
});
const _fs = /*#__PURE__*/ _interop_require_default(require("fs"));
const _util = require("util");
const _ncError = require("~/helpers/ncError");
const _MysqlClient = /*#__PURE__*/ _interop_require_default(require("~/db/sql-client/lib/mysql/MysqlClient"));
const _OracleClient = /*#__PURE__*/ _interop_require_default(require("~/db/sql-client/lib/oracle/OracleClient"));
const _SqliteClient = /*#__PURE__*/ _interop_require_default(require("~/db/sql-client/lib/sqlite/SqliteClient"));
const _PgClient = /*#__PURE__*/ _interop_require_default(require("~/db/sql-client/lib/pg/PgClient"));
const _YugabyteClient = /*#__PURE__*/ _interop_require_default(require("~/db/sql-client/lib/pg/YugabyteClient"));
const _TidbClient = /*#__PURE__*/ _interop_require_default(require("~/db/sql-client/lib/mysql/TidbClient"));
const _VitessClient = /*#__PURE__*/ _interop_require_default(require("~/db/sql-client/lib/mysql/VitessClient"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let SqlClientFactory = class SqlClientFactory {
    static create(connectionConfig) {
        var _connectionConfig_meta;
        connectionConfig.meta = connectionConfig.meta || {};
        connectionConfig.pool = connectionConfig.pool || {
            min: 0,
            max: 5
        };
        connectionConfig.meta.dbtype = connectionConfig.meta.dbtype || '';
        if (connectionConfig.client === 'mysql' || connectionConfig.client === 'mysql2') {
            if (connectionConfig.meta.dbtype === 'tidb') return new _TidbClient.default(connectionConfig);
            if (connectionConfig.meta.dbtype === 'vitess') return new _VitessClient.default(connectionConfig);
            return new _MysqlClient.default(connectionConfig);
        } else if (connectionConfig.client === 'sqlite3') {
            return new _SqliteClient.default(connectionConfig);
        } else if (connectionConfig.client === 'oracledb') {
            return new _OracleClient.default(connectionConfig);
        } else if (connectionConfig.client === 'pg') {
            if (connectionConfig.meta.dbtype === 'yugabyte') return new _YugabyteClient.default(connectionConfig);
            return new _PgClient.default(connectionConfig);
        }
        _ncError.NcError.notImplemented(`Database ${(connectionConfig == null ? void 0 : (_connectionConfig_meta = connectionConfig.meta) == null ? void 0 : _connectionConfig_meta.dbtype) || ''} is not supported`);
    }
};
let _class = class _class {
    static async create(connectionConfig) {
        if (connectionConfig.connection.ssl && typeof connectionConfig.connection.ssl === 'object') {
            if (connectionConfig.connection.ssl.caFilePath) {
                connectionConfig.connection.ssl.ca = (await (0, _util.promisify)(_fs.default.readFile)(connectionConfig.connection.ssl.caFilePath)).toString();
                delete connectionConfig.connection.ssl.caFilePath;
            }
            if (connectionConfig.connection.ssl.keyFilePath) {
                connectionConfig.connection.ssl.key = (await (0, _util.promisify)(_fs.default.readFile)(connectionConfig.connection.ssl.keyFilePath)).toString();
                delete connectionConfig.connection.ssl.keyFilePath;
            }
            if (connectionConfig.connection.ssl.certFilePath) {
                connectionConfig.connection.ssl.cert = (await (0, _util.promisify)(_fs.default.readFile)(connectionConfig.connection.ssl.certFilePath)).toString();
                delete connectionConfig.connection.ssl.certFilePath;
            }
        }
        return SqlClientFactory.create(connectionConfig);
    }
};
